import mixpanel from "mixpanel-browser"

export const MIX_TOKEN = '30d2d8d20594dd73c0cd7b872f608b5f'

export const MIX_CONFIG = {
    debug: false, api_host: 'https://owl.light-tech.online'
}

const isDev = document.title == 'dev'
// const isDev = false

const getComponentCount = () => {
    const instancesArr = JSON.parse(sessionStorage.getItem('impressiveTextSliderInstances')) || []
    return instancesArr.length;
}


const getSiteInfoPromisified = new Promise((resolve, reject) => {
    Wix.getSiteInfo(info => {
        resolve(info)
    })

    setTimeout(() => {
        reject('Timed out')
    }, 3000)
})

Array.prototype.pushUnique = function (element) {
    if (!this.includes(element)) {
        this.push(element)
    }
}

const filterErrors = (error) => {
    let filtered = false
    const messagesArray = [
        'Illegal invocation'
    ]
    if (messagesArray.includes(error.message) && error.stack.includes('chrome-extension://dbilanlcioamaadkbepcenpombaejbla/')) {
        filtered = true
    }

    return filtered
}

const transformLangCodeToLanguage = (code) => {
    switch (code.toLowerCase()) {
        case 'en':
            return 'English';
        case 'es':
            return 'Spanish';
        case 'fr':
            return 'French';
        case 'de':
            return 'German';
        case 'it':
            return 'Italian';
        case 'pt':
            return 'Portuguese';
        case 'ru':
            return 'Russian';
        case 'pl':
            return 'Polish';
        default:
            return 'Unknown';
    }
}

const editorTypeDecoder = (url = '') => {

    if (url == '' || url == undefined || url == null) {
        return 'unrecognized'
    }

    let [httpsPart, withoutHttps] = url.split('//')
    let slashDividedArray = withoutHttps.split('/')
    slashDividedArray.pop()

    if (slashDividedArray.includes('editor')) {
        return 'old-editor'
    } else if (slashDividedArray.includes('editor-x')) {
        return 'editor-x'
    } else if (slashDividedArray.includes('studio')) {
        return 'wix-studio'
    }

    return 'unrecognized'
}

const formStatsOfSlide = (slide) => {
    const types = []
    const animationsIn = []
    const animationsOut = []
    const animationsModeIn = [] 
    const animationsModeOut = [] 

    for (let caption of slide.captions) {
        types.push(caption.type)
        animationsIn.push(caption.animationIn)
        animationsOut.push(caption.animationOut)
        if (caption.animationModeIn) {
            animationsModeIn.push(caption.animationModeIn)
        }
        if (caption.animationModeOut) {
            animationsModeOut.push(caption.animationModeOut)
        }
    }

    let returnObject = {
        types,
        animationsIn,
        animationsOut,
        animationsModeIn,
        animationsModeOut
    }

    return returnObject
}

const formStatsOfSlideshow = (settings) => {
    const parallaxType = settings.hasParallax ? settings.parallaxType : 'none'
    const animationMode = settings.animationMode
    const sliderMode = settings.sliderMode
    const slidesAmount = settings.slides.length
    const backgroundType = settings.backgroundType

    let types = []
    let animationsIn = []
    let animationsOut = []
    let animationsModeIn = [] 
    let animationsModeOut = [] 

    for (let slide of settings.slides) {
        const stats = formStatsOfSlide(slide)
        types = types.concat(stats.types)
        animationsIn = animationsIn.concat(stats.animationsIn)
        animationsOut = animationsOut.concat(stats.animationsOut)
        animationsModeIn = animationsModeIn.concat(stats.animationsModeIn)
        animationsModeOut = animationsModeOut.concat(stats.animationsModeOut)
    }

    const settingsLanguage = settings.settingsLanguage ? transformLangCodeToLanguage(settings.settingsLanguage) : 'Unknown'

    let pickedPreset = 'no-preset'

    if (backgroundType === 'preset' && settings.backgroundPresetSettings) {
        pickedPreset = settings.backgroundPresetSettings.type
    } else if (backgroundType === 'preset-3d' && settings.backgroundPresetSettings) {
        pickedPreset = settings.backgroundPresetSettings.type3D
    }


    let returnObject = {
        parallaxType,
        animationMode,
        sliderMode,
        slidesAmount,
        backgroundType,
        pickedPreset,

        types,
        animationsIn,
        animationsOut,
        animationsModeIn,
        animationsModeOut,
        settingsLanguage
    }


    return returnObject
}


const initializeMix = () => {


    const instanceId = Wix.Utils.getInstanceId();

    mixpanel.init(MIX_TOKEN, MIX_CONFIG);
    mixpanel.identify(instanceId);
}

const saveSiteUrl = () => {
    getSiteInfoPromisified.then(data => {
        // console.log(data)
        mixpanel.people.set('Site', data.baseUrl)
        const editorType = editorTypeDecoder(data.referer)
        mixpanel.people.set('Editor type', editorType)
    }).catch(e => {
        console.log(e)
    })
}


const saveComponentsCount = () => {
    mixpanel.people.set('Slideshow amount', getComponentCount())
}

const savePremiumInfo = (isPremium) => {
    mixpanel.people.set('Plan', isPremium ? 'premium': 'free')
}

export const eventNames = {
    SETTINGS_OPENED: 'settings_opened',
    NEW_USER: 'new_user',
    BUTTON_CLICKED: {
        START: 'button_clicked_start',
        UPGRADE_MAIN: 'button_clicked_upgrade_main',
        UPGRADE_TAB: 'button_clicked_upgrade_tab',
        GIVE_FEEDBACK: 'button_clicked_give_feedback',
        KNOWLEDGE_BASE: 'button_clicked_knowledge_base',
        MORE_APPS_APP: 'button_clicked_more_apps_app',
        NEW_TEMPLATE: 'button_clicked_new_template',
        ADD_FONT: 'button_clicked_add_font',
        TRY_IT_NOW_PRO_TEMPLATES: 'button_clicked_try_it_now_pro_templates',
        COPY_CODE_COUPON: 'button_clicked_copy_coupon_code',
        UPGRADE_COUPON: 'button_clicked_upgrade_coupon',
        TEMPLATE_TUTORIAL_CLICKED: 'button_clicked_template_tutorial'
    },
    TAB_CLICKED: {
        MORE_APPS: 'tab_clicked_more_apps',
        SUPPORT: 'tab_clicked_support',
        TEMPLATES: 'tab_clicked_templates',
        CUSTOM_FONT: 'tab_clicked_custom_font',
        SCENE: 'tab_clicked_scene'
    },
    PRO_TEMPLATES: {
        WATCHED: 'pro_templates_watched',
        APPLIED: 'pro_templates_applied',
        CLOSED: 'pro_templates_closed'
    },
    FIRST_ADDED: 'first_added',
    SLIDESHOW_CREATED: 'slideshow_created',
    SLIDESHOW_SAVED: 'slideshow_saved',
    SLIDESHOW_PUBLISHED: 'slideshow_published',
    SLIDESHOW_DELETED: 'slideshow_deleted',
    SLIDE_APPLIED: 'slide_applied',
    SLIDE_CANCELLED: 'slide_cancelled',
    FAQ_OPENED_SETTINGS: 'faq_opened_settings',
    FAQ_OPENED_EDIT_SLIDE: 'faq_opened_edit_slide',
    ERROR_CATCHED: 'error_catched',
    RESOURCES_NOT_LOADED: 'resources_not_loaded',
    EXTENDED_TRIAL_USED: 'extended_trial_used',
}


const settingsOpened = () => {
    if (isDev) {
        return;
    }
    saveSiteUrl()
    saveComponentsCount()
    mixpanel.track(eventNames.SETTINGS_OPENED)
}

const newUserAdded = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.NEW_USER)
}

const firstAdded = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.FIRST_ADDED)
}

const slideshowCreated = () => {
    if (isDev) {
        return;
    }
    saveSiteUrl()
    mixpanel.track(eventNames.SLIDESHOW_CREATED)
}

const slideshowSaved = (settings = {}) => {
    // console.log(formStatsOfSlideshow(settings))
    if (isDev) {
        return;
    }
    const slideshowStats = formStatsOfSlideshow(settings)
    mixpanel.track(eventNames.SLIDESHOW_SAVED, slideshowStats)
}

const slideshowPublished = (settings = {}) => {
    if (isDev) {
        return;
    }
    const slideshowStats = formStatsOfSlideshow(settings)
    mixpanel.track(eventNames.SLIDESHOW_PUBLISHED, slideshowStats)
}

const slideshowDeleted = (settings = {}) => {
    if (isDev) {
        return;
    }
    saveComponentsCount()
    const slideshowStats = formStatsOfSlideshow(settings)
    mixpanel.track(eventNames.SLIDESHOW_DELETED, slideshowStats)
}

const slideApplied = (slide = {}) => {
    if (isDev) {
        return;
    }
    const slideStats = formStatsOfSlide(slide)

    mixpanel.track(eventNames.SLIDE_APPLIED, slideStats)
}

const slideApplyCancelled = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.SLIDE_CANCELLED)
}

const buttonClickedGiveFeedback = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.BUTTON_CLICKED.GIVE_FEEDBACK)
}

const buttonClickedUpgradeMain = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.BUTTON_CLICKED.UPGRADE_MAIN)
}

const buttonClickedUpgradeTab = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.BUTTON_CLICKED.UPGRADE_TAB)
}

const buttonClickedKnowledgeBase = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.BUTTON_CLICKED.KNOWLEDGE_BASE)
}

const buttonClickedAddedFont = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.BUTTON_CLICKED.ADD_FONT)
}

const templateTutorialClicked = (templateName = '') => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.BUTTON_CLICKED.TEMPLATE_TUTORIAL_CLICKED, { template: templateName })
}

const tabCustomFontOpened = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.TAB_CLICKED.CUSTOM_FONT)
}




const moreAppsTabClicked = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.TAB_CLICKED.MORE_APPS)
}

const moreAppsAppClicked = (app = '') => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.BUTTON_CLICKED.MORE_APPS_APP, { appName: app })
}

const sceneTabClicked = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.TAB_CLICKED.SCENE)
}


const faqOpenedSettings = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.FAQ_OPENED_SETTINGS)
}

const faqOpenedEditSlide = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.FAQ_OPENED_EDIT_SLIDE)
}

const proTemplateWatched = (name) => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.PRO_TEMPLATES.WATCHED, { template: name })
}

const proTemplateApplied = (name) => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.PRO_TEMPLATES.APPLIED, { template: name })
}

const proTemplatesClosed = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.PRO_TEMPLATES.CLOSED)
}

const tryItNowClicked = () => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.BUTTON_CLICKED.TRY_IT_NOW_PRO_TEMPLATES)
}

const errorCatched = (error, info) => {
    // console.log('errorCatched', error, info)
    if (isDev) {
        return;
    }
    if (filterErrors(error)) {
        return;
    }
    mixpanel.track(eventNames.ERROR_CATCHED, { error: { error: error.message, stack: error.stack }, info: info })
}

const couponCopyCode = (isNewUser) => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.BUTTON_CLICKED.COPY_CODE_COUPON, { isNewUser: isNewUser })
}

const resourcesNotLoaded = (resources) => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.RESOURCES_NOT_LOADED, { resources })
}

const extendedTrialUsed = (sourceApp = '') => {
    if (isDev) {
        return;
    }
    mixpanel.track(eventNames.EXTENDED_TRIAL_USED, { sourceApp })
}

export const MixHelper = {
    initializeMix,
    savePremiumInfo,
    events: {
        settingsOpened,
        newUserAdded,
        firstAdded,
        slideshowCreated,
        slideshowSaved,
        slideshowPublished,
        slideshowDeleted,
        slideApplied,
        slideApplyCancelled,
        faqOpenedSettings,
        faqOpenedEditSlide,
        errorCatched,
        resourcesNotLoaded,
        extendedTrialUsed,
        button: {
            buttonClickedGiveFeedback,
            buttonClickedUpgradeMain,
            buttonClickedAddedFont,
            buttonClickedKnowledgeBase,
            buttonClickedUpgradeTab,
            moreAppsAppClicked,
            tryItNowClicked,
            couponCopyCode,
            templateTutorialClicked
        },
        tab: {
            tabCustomFontOpened,
            moreAppsTabClicked,
            sceneTabClicked
        },
        proTemplates: {
            watched: proTemplateWatched,
            applied: proTemplateApplied,
            closed: proTemplatesClosed
        }
    }
}